import { MEDIA_HM_PATH } from "@project/shared-types";
import React, { useState } from "react";
import CloseSvg from "../../assets/taiga-uikit/icons/close.svg?react";
import { _size, _sizeText, _typeLabel } from "../../core/core";
import { Text } from "../texts/text";
import "./Tag.css";

interface TagProps {
  name?: string | null;
  icon?: string | null;
  onClick?: (name: string | null, isActive: boolean) => void;
  size?: _size;
  type?: _typeLabel;
  onClickClose?: (name: string | null) => void;
  is_active?: boolean;
  is_active_desable?: boolean;
  children?: React.ReactNode;
}

export const Tag: React.FC<TagProps> = ({
  name = null,
  icon = null,
  onClick = null,
  size = _size.M,
  type = _typeLabel.primary,
  onClickClose = null,
  is_active = false,
  is_active_desable = true,
  children,
  ...props
}) => {
  const [active, setActive] = useState<boolean>(is_active);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (onClick) {
      onClick(name, !active);
    }
    if (is_active_desable) {
      setActive(!active);
    }
  };

  const handleCloseClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (onClickClose) {
      onClickClose(name);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`tag tag-${size} tag-${type}-${active}`}
      {...props}
    >
      <div className="tag-bdy">
        <div className="tag-name">
          <Text size={_sizeText.m}>{name}</Text>
        </div>
        {icon && (
          <img
            height="16"
            width="16"
            src={`${MEDIA_HM_PATH}${icon}`}
            alt={`иконка svg ${name}`}
          />
        )}
      </div>
      {active && (
        <div onClick={handleCloseClick}>
          <CloseSvg />
        </div>
      )}
    </div>
  );
};
